module.exports = __webpack_public_path__ + "static/media/piña_big.bd94fb1c.png";